import PropTypes from "prop-types";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// project import
import useAuth from '../../hooks/useAuth';
import { AUTH_REDIRECT_REASON, consumeAuthRedirectReason, setAuthRedirectReason } from '../authRedirect';
import { getAuthenticatedTenantId, getRequestedTenantId } from '../tenantEmailAccess';

// ==============================|| AUTH GUARD ||============================== //

const AuthGuard = ({ children }) => {
  const { isLoggedIn, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const requestedTenantId = getRequestedTenantId(location);
  const authenticatedTenantId = getAuthenticatedTenantId();
  const mustSwitchTenant = Boolean(
    isLoggedIn && requestedTenantId && requestedTenantId !== authenticatedTenantId
  );

  useEffect(() => {
    if (mustSwitchTenant) {
      logout();
      setAuthRedirectReason(AUTH_REDIRECT_REASON.AUTH_REQUIRED);
      navigate('/login', {
        state: {
          from: location.pathname + location.search,
          tenantId: requestedTenantId,
          reason: AUTH_REDIRECT_REASON.AUTH_REQUIRED
        },
        replace: true
      });
      return;
    }

    if (!isLoggedIn) {
      const redirectReason = consumeAuthRedirectReason();

      if (redirectReason === AUTH_REDIRECT_REASON.LOGOUT) {
        navigate('/login', {
          state: {
            reason: AUTH_REDIRECT_REASON.LOGOUT
          },
          replace: true
        });
        return;
      }

      navigate('/login', {
        state: {
          from: location.pathname + location.search,
          tenantId: requestedTenantId,
          reason: AUTH_REDIRECT_REASON.AUTH_REQUIRED
        },
        replace: true,
      });
    }
  }, [isLoggedIn, location.pathname, location.search, logout, mustSwitchTenant, navigate, requestedTenantId]);

  return isLoggedIn && !mustSwitchTenant ? children : null;
};

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default AuthGuard;
